import type { FeConfig } from "@ceeferenderer/fe-renderer-sdk";
import { FetchClientProvider } from "../utils/FetchClientProvider";
import { loggingFetch } from "../utils/loggingFetch";

export const itgConfig: FeConfig = {
  applicationName: "Retail",
  cssApplicationName: "FESDK",
  encrypt: {
    iv: "101112131415161718191a1b1c1d1e1f",
    mode: "CTR",
    padding: "Iso10126",
    type: "DES",
  },
  internalCall: true,
  isServiceProtected: false,
  restClientProvider: new FetchClientProvider(loggingFetch),

  /* these can not be full URIs, they can only be the path to that specific endpoint */
  /* ITGProcess and ITGStep endpoints replaced with flowExecute as part of FE Migration*/
  startItgURI: "/flowExecute",
  stepItgURI: "/flowExecute",
};
